/**
 * Android hardware/gesture back handling for overlays.
 *
 * Overlays (chat, modals) push a "close me" handler while they're open. The
 * native back button (wired in capacitorInit) runs the top handler first, so
 * back closes the open overlay instead of navigating the page or exiting the
 * app. If nothing is registered, back falls through to history/exit.
 *
 * No-op on web (nothing calls runTopBackHandler there).
 */
const handlers = [];

/** Register an overlay's close handler; returns an unregister function. */
export function pushBackHandler(fn) {
  handlers.push(fn);
  return function unregister() {
    const i = handlers.indexOf(fn);
    if (i !== -1) handlers.splice(i, 1);
  };
}

/** Run the most-recently-registered handler. Returns true if one handled it. */
export function runTopBackHandler() {
  const fn = handlers[handlers.length - 1];
  if (!fn) return false;
  try {
    fn();
  } catch (e) {
    /* ignore — still counts as handled so we don't also navigate */
  }
  return true;
}
